// extracted by mini-css-extract-plugin
export var colorSquare = "_rl-0";
export var danger = "_rl-5";
export var lightPink = "_rl-8";
export var neutralBlue = "_rl-7";
export var neutralYellow = "_rl-6";
export var normal = "_rl-1";
export var primary = "_rl-2";
export var primaryLight = "_rl-3";
export var solidBlack = "_rl-g";
export var solidGreen = "_rl-b";
export var solidLightBlue = "_rl-d";
export var solidNavy = "_rl-c";
export var solidOrange = "_rl-f";
export var solidPink = "_rl-e";
export var solidRed = "_rl-9";
export var solidYellow = "_rl-a";
export var success = "_rl-4";